<template>
    <div class="makemodelstepone">
        <div class="topheader">
            <div class="topheaderleft">
                欢迎您---{{username}}
            </div>
            <div class="topheaderright">
               <div class="back" @click="Back">
                   <i class="el-icon-arrow-left"></i>
                   <span>返回</span>
               </div>
               <div class="outlogin" @click="OutLogin">
                    <i class="el-icon-switch-button"></i>
                    <span>退出</span>
               </div>
            </div>

        </div>
    <div class="content">
        
        <div class="kh-list">
            <div class="kh-list-title">
                <span class="kh-list-title-tips">模型信息列表</span>
                <!-- <div class="kh-btns">
                    <el-button type="success" class="addkh-btn" @click="AddMxVisible=true">添加模型</el-button>
                </div> -->
            </div>
            <div class="kh-search">
              <el-form :inline="true" :model="MxSelect" class="demo-form-inline">
                  <el-form-item label="" class="khnum">
                      <el-input placeholder="模型名称" prefix-icon="el-icon-search" v-model="MxSelect.mxmc">
                    </el-input>
                  </el-form-item>
                  <el-form-item label="" class="khnum">
                      <el-input placeholder="作物" prefix-icon="el-icon-search" v-model="MxSelect.zwmc">
                    </el-input>
                  </el-form-item>
                  <el-form-item label="" class="khnum">
                      <el-input placeholder="品种" prefix-icon="el-icon-search" v-model="MxSelect.pzmc">
                    </el-input>
                  </el-form-item>
   
  
                </el-form>
                <el-button type="primary" @click="onSubmit" icon="el-icon-search">搜索</el-button>
          </div>
            <el-table :data="MxListData" border style="width: 100%">
                <el-table-column
                label="序号"
                align="center" width="50">
                  <template slot-scope="scope"> 
                    <span>{{scope.$index+1}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                label="模型名称"
               :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <el-link  target="_blank" type="primary" @click="SeeMxShowDet(scope.row.mode_num)">{{scope.row.mode_name}}</el-link>
              </template>
                </el-table-column>
                <el-table-column
                prop="zw_name"
                label="作物"
                align="center" width="80":show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column  
                prop="pz_name"            
                label="品种"
                :show-overflow-tooltip="true" align="center">
              
                </el-table-column>
                <el-table-column
                label="创建时间"
                :show-overflow-tooltip="true">
                <template slot-scope="scope"> 
                  <span>{{ChangeTime(scope.row.creat_time)}}</span>
                </template>
               
                </el-table-column>
                <el-table-column
                prop="yjsc"
                label="预估收成(KG/亩)"
                :show-overflow-tooltip="true" align="center">
                </el-table-column>
                <el-table-column
                prop="sy_zq"
                label="生育周期(天)"
                align="center":show-overflow-tooltip="true">
                </el-table-column>            
                <el-table-column label="操作" align="center" width="200">
                    <template slot-scope="scope">
                      <!-- <el-button size="mini" type="success" icon="el-icon-view" @click="SeeDet(scope.row.id)" title="查看"></el-button> -->
                      <el-button
                      size="mini"
                      type="primary"
                      icon="el-icon-edit"
                      @click="EditMsg(scope.row.mode_num)" title="修改"></el-button>
                      <el-button
                      size="mini"
                      type="danger"
                      icon="el-icon-delete"
                      @click="DeleteMsg(scope.row.mode_num)" title="删除"></el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="block pages">
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page.sync="pagenum"
                  :page-size="limit"
                  layout="prev, pager, next, jumper"
                  :total="zwtotal">
                </el-pagination>
              </div>
        </div>
    </div>  
    </div>
  </template>
  
  <script>
    import storage from '../../Storage/storage.js';
    export default {
      name: "Makemodelstepthree",
      data() {
        return {
          username:'',
          userid:'',
          myHeaders: {token: ""}, 
          pagenum:1,
          limit:10,
          zwtotal:0,
          MxSelect: {
            mxmc: '',  
            zwmc:'',
            pzmc:'',
          },
          MxListData: [],
        }
},
    methods: {
        Back(){
          this.$router.push({
                    path: '/main',
                    query: {
                    }
          }) 
        },
        OutLogin(){
          storage.remove('token');
          storage.remove('userid');
          storage.remove('username');
          this.$router.push({
                    path: '/',
                    query: {
                    }
          }) 
        },
        onSubmit(){
          this.GetModelList(this.userid,this.MxSelect.zwmc,this.MxSelect.pzmc,this.MxSelect.mxmc,this.pagenum,this.limit);
        },
        GetModelList(userid,zuowu,pinzhong,name,pagenum,limit){
          var Lookmodellist=this.GLOBAL.Lookmodellist;
                this.$http.post(Lookmodellist,{userid:userid,zuowu:zuowu,pinzhong:pinzhong,name:name,
                  page:pagenum,limit:limit},{'headers': {'Content-Type': 'application/json','token':this.myHeaders.token}},{emulateJSON:true}).then(function(res){
                      // console.log(res); 
                      if(res.body.code==0){
                        this.MxListData=res.body.data.list;
                        this.zwtotal=parseInt(res.body.data.total);

                      }
                                         
                },function(err){})
        },
        handleSizeChange(val) {
          // console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
          // console.log(`当前页: ${val}`);
          this.pagenum=val;
          this.GetModelList(this.userid,this.MxSelect.zwmc,this.MxSelect.pzmc,this.MxSelect.mxmc,this.pagenum,this.limit);
        },

        ChangeTime(time){
          var d = new Date(time);
          var times=d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();
          return times
        },
        DeleteMsg(num){
          var Deletemodel=this.GLOBAL.Deletemodel;
                this.$http.post(Deletemodel,{num:num},{'headers': {'Content-Type': 'application/json','token':this.myHeaders.token}},{emulateJSON:true}).then(function(res){
                      // console.log(res); 
                      if(res.body.code==0){
                       
                        this.GetModelList(this.userid,this.MxSelect.zwmc,this.MxSelect.pzmc,this.MxSelect.mxmc,this.pagenum,this.limit);
                      }
                                         
                },function(err){})

        },
        SeeMxShowDet(modenum){
          this.$router.push({
                  path: 'seemodeldet',
                  query: {
                    modenum:modenum
                  }
            }) 

        },
        EditMsg(modenum){
          this.$router.push({
                  path: 'resmodelone',
                  query: {
                    modenum:modenum
                  }
            }) 

        }
        
      },
      mounted() {
        this.username=storage.get('username');
        this.myHeaders.token=storage.get('token');
        this.userid=storage.get('userid');
        if(this.userid==''){
            this.$router.push({
                  path: '/',
                  query: {
                  }
            }) 
        }
        this.GetModelList(this.userid,this.MxSelect.zwmc,this.MxSelect.pzmc,this.MxSelect.mxmc,this.pagenum,this.limit);
      },
    }
  </script>
  
  <style  scoped>
    .topheader{
        width: 100%;
        height: 40px;
        background: #3a8ee6;
        display: flex;
    }
    .topheaderleft{
        width: 50%;
        height: 40px;
        padding-left: 20px;
        line-height: 40px;
        box-sizing: border-box;
        text-align: left;
        color: #ffffff;
        font-size: 16px;
    }
    .topheaderright{
        width: 50%;
        height: 40px;
        padding-right: 20px;
        line-height: 40px;
        box-sizing: border-box;
        color: #ffffff;
        font-size: 16px;
        display: flex;
        justify-content: flex-end;
    }
    .back{
        cursor: pointer;
        font-size: 14px;
    }
    .outlogin{
        margin-left: 20px;
        font-size: 14px;
        cursor: pointer;
    }
    .content{
        width: 80%;
        margin-left: 10%;
        margin-top: 20px;
    }
    .kh-search{
   width: 100%;
   display: flex;
   justify-content: space-between;
   margin: 20px 0px;
}
.khnum {
   width: 160px;
}
.el-select /deep/.el-input__inner{
   width: 120px;
}

.line{
   text-align: center;
}
.kh-search .el-form--inline .el-form-item{
   margin-bottom: 0px;
   margin-right: 0px;
}
/*商品列表*/
.kh-list{
width: 100%;
}

.kh-list-title{
width: 100%;
display: flex;
justify-content: space-between;
margin-top: 20px;
margin-bottom: 20px;
}
.kh-list-title-tips{
width: 120px;
height: 36px;
line-height: 36px;
font-weight: 600;

}
.kh-btns{
width: 300px;
text-align: right;
}
.el-table /deep/ th{
background:#eeeeee ;
border-color: #dddddd ;
color: #000000;
text-align: center;
}
.el-dropdown-link {
cursor: pointer;
color: #409EFF;
}
.el-icon-arrow-down {
font-size: 12px;
}
.el-date-editor--daterange.el-input, .el-date-editor--daterange.el-input__inner, .el-date-editor--timerange.el-input, .el-date-editor--timerange.el-input__inner{
    width: 200px !important;
}
.pages{
    text-align: right;
    margin-top: 10px;
}
  </style>
  


// WEBPACK FOOTER //
// src/components/SEEMODEL/seemodel.vue